var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m466 39.989h-420c-25.364 0-46 20.636-46 46v260c0 25.365 20.636 46 46 46h18v41.856c0 15.059 8.499 28.323 22.18 34.615 5.18 2.383 10.634 3.551 16.034 3.551 8.863 0 17.578-3.147 24.683-9.237.287-.246.565-.502.835-.768l70.841-70.017h267.427c25.364 0 46-20.635 46-46v-260c0-25.364-20.636-46-46-46zm-95.041 160.057-43.935 43.297c-1.163 1.146-1.693 2.788-1.42 4.398l10.383 61.205c.845 4.983-.499 10.172-3.935 13.879-3.167 3.417-7.461 5.164-11.779 5.164-2.571 0-5.15-.619-7.508-1.872l-54.419-28.925c-1.467-.78-3.226-.78-4.693 0l-54.085 28.748c-4.505 2.395-9.912 2.736-14.538.586-6.689-3.11-10.269-10.199-9.08-17.212l10.445-61.572c.273-1.61-.257-3.251-1.42-4.398l-43.935-43.297c-3.613-3.561-5.561-8.581-4.925-13.614.92-7.291 6.547-12.85 13.559-13.88l60.903-8.947c1.633-.24 3.042-1.27 3.766-2.754l27.112-55.54c2.246-4.6 6.44-8.061 11.467-9.028 7.261-1.396 14.329 2.279 17.456 8.687l27.278 55.881c.724 1.483 2.133 2.514 3.766 2.754l60.903 8.947c7.012 1.03 12.638 6.59 13.559 13.88.636 5.032-1.311 10.052-4.925 13.613z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.b22f13bd121935470f8a7a35331972f6.svg";
export { ForwardRef as ReactComponent };